// This stores UTM parameters into the browser's localStorage.
(function() {
   const url = new URL(location);
   const paramNames = ['utm_medium', 'utm_source', 'utm_campaign', 'utm_content'];
   const ONE_HOUR_IN_MS = 3600000;
   let utmParams = {};
   let hasUtmParams = false;
   let paramValue;
   let curTrackers;
   let newTrackers;

   paramNames.forEach(function(param) {
      paramValue = url.searchParams.get(param);
      if (paramValue) {
         utmParams[param] = paramValue;
         hasUtmParams = true;
      }
   });

   if (hasUtmParams) {
      utmParams.timestamp = Date.now();
      curTrackers = localStorage.getItem('utmTrackers');
      if (curTrackers) {
         try {
            curTrackers = JSON.parse(curTrackers);
            // If we have a stored tracker from the same campaign from
            // within 1 hour ago, don't add a new one.
            if (
               curTrackers.filter(
                  obj =>
                     obj.utm_campaign === utmParams.utm_campaign &&
                     obj.timestamp > utmParams.timestamp - ONE_HOUR_IN_MS
               ).length
            ) {
               newTrackers = curTrackers;
            } else {
               newTrackers = curTrackers.concat([utmParams]);
            }
         } catch (err) {
            newTrackers = [utmParams];
         }
      } else {
         newTrackers = [utmParams];
      }
      localStorage.setItem('utmTrackers', JSON.stringify(newTrackers));
   }
})();
